import { Pipe, PipeTransform } from '@angular/core';
import { Payment } from '../../../../../core/models/ticket.model';

@Pipe({
  name: 'paymentType',
  standalone: true,
})
export class PaymentTypePipe implements PipeTransform {
  transform(payment: Payment):string {
    return `transaction.ticket.payment.${payment.paymentType.toLowerCase()}`;
  }
}
